import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {Guid} from "../../helpers/guid-helper";

@Component({
  selector: 'components-checkbox',
  imports: [
    FormsModule
  ],
  templateUrl: './checkbox.component.html',
  styleUrl: './checkbox.component.scss'
})
export class CheckboxComponent {
  @Input() id: any = Guid.newGuid();

  @Input() isChecked: boolean = false;
  @Output() isCheckedChange = new EventEmitter<boolean>();

  @Input() disabled: boolean = false;

  @Input() label: string = "";
}
